import _ from "lodash";
import axios from "axios";

export async function callServer(_method, _endpoint, _data) {
  try {
    const API_SERVER = process.env.REACT_APP_BACKEND_URL;
    let method = _.toString(_method).toLowerCase();
    let endpoint = API_SERVER + _.toString(_endpoint);
    let data = _.clone(_data) || {};
    let accessToken = localStorage.getItem('accessToken');

    let resp = await axios[method](
      endpoint,
      method === "get"
        ? { params: data, headers: { AccessToken: accessToken } }
        : data,
      method === "post" || method === "put"
        ? { headers: { AccessToken: accessToken } }
        : {}
    );
    let respData = resp.data;
    let { status, errorCode, errorMessage, result } = respData;
    if (status <= 0) {
      let errorObj = {
        status,
        errorCode,
        errorMessage,
      };
      return errorObj;
    }
    if (result) {
      return result;
    }
    return respData;
  } catch (err) {
    console.error(err);
  }
  return null;
}